export const AddNotification = (notificSystem, notificLevel, messageTitle, messageBody) => {
  notificSystem.addNotification({
    message: messageBody,
    title: messageTitle,
    level: notificLevel,
    position: 'bl'
  });
};

export const NotificStyle = {
  NotificationItem: {
    // Override the notification item
    DefaultStyle: {
      // Applied to every notification, regardless of the notification level
      border: '2px solid #174E75',
      margin: '20px 10px 0 0'
    },
    success: {
      // Applied only to the success notification item
      // color: 'red'
    }
  }
};
